// src/hooks/useApiCall.js
import { useState, useCallback } from 'react';

export const useApiCall = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const makeRequest = useCallback(async (requestFn, loadingMessage = 'Loading...') => {
    setLoading(true);
    setError(null);
    try {
      const result = await requestFn();
      return result;
    } catch (err) {
      // An aborted request (caller navigated away / a polling cycle
      // canceled it) is expected cancellation, not a failure — don't log it
      // or surface it through error state.
      if (err?.name !== 'AbortError') {
        console.error('API request failed:', err);
        setError(err.message || 'An unexpected error occurred');
      }
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    loading,
    error,
    isStartingUp: false,   // kept for backward compatibility
    startupMessage: '',    // kept for backward compatibility
    makeRequest,
    clearError
  };
};
